export interface SearchReserveSetRequest {
  key: string
}

export function SearchReserveSetRequestToJSON(
  value: SearchReserveSetRequest
): any {
  return {
    key: value.key !== '' ? value.key : undefined
  }
}
